module.exports = __webpack_public_path__ + "static/media/statics_classroom2.0e9d1025.jpg";